import { HighlightedDetailField } from "../../../components";
import { useStationListWithCache } from "../../../components/StationHookFormSelect";

import { FieldGrid } from "../styles";
import { Section, SectionSubHeader } from "../components";

const PartAutoclave = ({ section = {} }) => {
  const config = section?.config || {};
  const route = section?.routing?.[0];
  const { stations = [] } = useStationListWithCache();
  const station = route?.stationId
    ? stations.find((s) => s.id === route.stationId)
    : null;

  return (
    <Section icon="Fire" label="Dewax Department" spanishLabel="Desencerado">
      <FieldGrid columns={3}>
        <HighlightedDetailField
          label="Station"
          spanishLabel="Estación"
          value={station?.label}
        />
        <HighlightedDetailField
          label="Trees / Load"
          spanishLabel="Árboles por Carga"
          value={config?.treesPerLoad}
        />
        <HighlightedDetailField
          label="Dewaxed Shell Weight"
          spanishLabel="Peso de la Cáscara Desencerada"
          value={config?.dewaxedShellWeight}
        />
      </FieldGrid>

      <SectionSubHeader label="Notes" spanishLabel="Notas" />
      <HighlightedDetailField
        label="Notes"
        spanishLabel="Notas"
        value={section?.notes}
      />
    </Section>
  );
};

export default PartAutoclave;
